module.exports = __webpack_public_path__ + "img/io.7d468883.png";